import {useMutation, useQueryClient} from "@tanstack/react-query";

import {useInvalidate} from "@/src/modules/core/hooks";
import {errorHandler} from "@/src/modules/core/lib";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {safelistingsService} from "../services";

export default function useCreateSafelisting() {
  const queryClient = useQueryClient();
  const invalidateSafelistings = useInvalidate("safelistings");

  return useMutation({
    mutationFn: safelistingsService.createSafelisting,
    onSuccess: (data, variables) => {
      invalidateSafelistings();
      const rawId = data.vehicle?.vehicle_id ?? variables.vehicle_id;
      const vehicleId = typeof rawId === "number" ? rawId : Number(rawId);
      if (Number.isFinite(vehicleId)) {
        void queryClient.invalidateQueries({queryKey: ["vehicles", vehicleId]});
      }
    },
    onError: (error) => {
      captureParkingSubmitError(error, {feature: "safelistings", operation: "safelisting_create"});
      errorHandler(error);
    },
  });
}
